import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98e8367e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center fw-bold" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "table table-hover" }
const _hoisted_8 = { ref: "tbody" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  scope: "row",
  class: "test-properties"
}
const _hoisted_11 = ["checked", "disabled"]
const _hoisted_12 = ["checked", "disabled"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "btn-group float-end" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 1,
  class: "card mb-3"
}
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { class: "card-text" }

import Layout from "@/components/Layout.vue";
import CameraFeed from "@/components/CameraFeed.vue";
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { MainService } from "@/services/main.service";
import { useRouter } from "vue-router";
import * as DOMPurify from "dompurify";
import { QuestionModel } from "@/models/question.model";
import { AlertManager } from "@/services/alert.manager";
import VueCountdown from '@chenfengyuan/vue-countdown';
import Navigation from "@/components/Navigation.vue";
import { useLogout } from "@/hooks/logout.hook";
import { useTranslate } from "@/hooks/translate.hook";
import Swal from "sweetalert2";


export default /*#__PURE__*/_defineComponent({
  __name: 'TestView',
  setup(__props) {

const question = ref<QuestionModel>()
const selected = ref<number[]>([])
const disabled = ref<boolean>(true)
const workId = ref<number>()
const countdownEndReached = ref<boolean>(false);
const showCheatingAlert = ref<boolean>(true);
const logout = useLogout()
const router = useRouter()
const t = useTranslate()

function addLeadingZero(num: number) {
  let numStr = num.toString();
  if (numStr.length === 1) {
    numStr = '0' + numStr;
  }
  return numStr;
}

const isFocused = computed(() => {
  if (isDebugEnabled()) {
    return true
  }
  return isWindowFocused.value && isMouseFocused.value;
});

const isWindowFocused = ref(true);
const isMouseFocused = ref(true);

watch([isFocused], async () => {
  if (showCheatingAlert.value) {
    showCheatingAlert.value = false
    MainService.saveStudentCheatingAttempt()
      .then(rsp => console.log('Cheating recorded'))
      .catch(e => (e.message == 'CREATE_FAILED') ? showResult() : logout())
    await AlertManager.warning(
      t('page.test.focus.title'),
      t('page.test.focus.desc'),
    )
    showCheatingAlert.value = true
  }
});

const handleVisibilityChange = () => {
  if (isDebugEnabled()) {
    isWindowFocused.value = true
    return
  }

  isWindowFocused.value = !document.hidden;
};

function isMouseInsideWindow(event: MouseEvent): boolean {

  const delta = 5;

  return (
    event.clientX >= delta &&
    event.clientY >= delta &&
    event.clientX <= window.innerWidth - delta &&
    event.clientY <= window.innerHeight - delta
  );
}

function handleMouseMoveEvent(event: MouseEvent) {
  if (isDebugEnabled()) {
    isMouseFocused.value = true
    return
  }

  if (isMouseInsideWindow(event)) {
    isMouseFocused.value = true
  } else {
    isMouseFocused.value = false
  }
}

let interval = setInterval(() => {
  isWindowFocused.value = document.hasFocus()
}, 500)

onMounted(() => {
  handleVisibilityChange();
  document.addEventListener('visibilitychange', handleVisibilityChange);
  window.addEventListener('mousemove', handleMouseMoveEvent);
  document.addEventListener('mouseleave', handleMouseMoveEvent)
});

onBeforeUnmount(() => {
  document.removeEventListener('visibilitychange', handleVisibilityChange);
  window.removeEventListener('mousemove', handleMouseMoveEvent);
  document.removeEventListener('mouseleave', handleMouseMoveEvent)
  clearInterval(interval)
});

function isDebugEnabled() {
  if (process.env.VUE_APP_ALLOW_DEBUG_MODE === "true")
    return localStorage.getItem('debug') != null && localStorage.getItem('debug') == '1'
  return false
}

async function onCountdownEndReached() {
  if (!countdownEndReached.value) {
    countdownEndReached.value = true
    await MainService.finishCurrentStudentTest(question.value!.workId)
    showResult()
  }
}

function selectAnswer(index: number) {
  if (disabled.value) return;
  if (question.value?.multiChoice) {
    // Multiple answers
    if (selected.value.includes(index)) {
      selected.value = selected.value.filter(a => a !== index)
      return
    }

    // Samo dodaj odgovor
    selected.value.push(index)
    return
  }

  // Single choice, remove if it exists
  if (selected.value.length === 1) {
    if (selected.value[0] === index) {
      selected.value = []
      return;
    }

    selected.value = []
    selected.value.push(index)
    return;
  }

  // dodaj odgovor
  selected.value.push(index)
}

function nextQuestion() {
  if (question.value == undefined) {
    return
  }

  disabled.value = true
  const answers = selected.value.map(idx => question.value!.answers[idx])
  question.value = undefined
  MainService.sendAnswers(answers)
    .then(rsp => {
      selected.value = []
      loadNewQuestion()
    })
    .catch(e => {
      if (e.message == 'NOT_FOUND' || e.message == 'CREATE_FAILED' || e.message == "UPDATE_FAILED") {
        showResult()
        return
      }
      logout()
    })
}

function loadNewQuestion() {
  MainService.getNextStudentTestQuestion()
    .then(rsp => {
      question.value = rsp.data
      workId.value = rsp.data.workId
      sessionStorage.setItem('std-work-id', rsp.data.workId)
      disabled.value = false
    })
    .catch(e => {
      // Make sure the work id is undefined if its not parsable
      const parsed = parseInt(sessionStorage.getItem('std-work-id') ?? "")
      workId.value = isNaN(parsed) ? undefined : parsed;

      if (e.message == 'NOT_FOUND' || e.message == 'CREATE_FAILED' || e.message == "UPDATE_FAILED") {
        showResult()
        return
      }
      logout()
    })
}

function finishTestButtonClickHandler() {
  if (question.value == undefined) return
  if (question.value.totalOpened != question.value.totalQuestions) {
    AlertManager.confirm(
      t('page.test.confirm.title'),
      t('page.test.confirm.desc'),
      t('page.test.confirm.yes'),
      t('page.test.confirm.no'),
      () => {
        finishCurrentTest()
      })
    return
  }
  finishCurrentTest()
}

async function finishCurrentTest() {
  if (question.value == undefined) return
  AlertManager.showLoading()

  try {
    disabled.value = true
    const answers = selected.value.map(idx => question.value!.answers[idx])
    await MainService.sendAnswers(answers)
    await MainService.finishCurrentStudentTest(question.value!.workId)
    Swal.close()
    showResult()
  } catch (e: any) {
    console.error(e)
    Swal.close()
    if (e.message == 'NOT_FOUND' || e.message == 'CREATE_FAILED' || e.message == "UPDATE_FAILED") {
      showResult()
      return
    }
    logout()
  }
}

function showResult() {
  if (workId.value == undefined) {
    router.push({
      path: '/list'
    })
    return
  }

  router.push({
    path: '/result/' + workId.value
  })
}

function getCountdownTime() {
  if (question.value == undefined)
    return 0
  return new Date(question.value?.deadline).getTime() - new Date().getTime()
}

onMounted(() => {
  // Ucitaj inicijalno pitanje
  loadNewQuestion()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navigation, { show: false }),
    _createVNode(Layout, null, {
      main: _withCtx(() => [
        (question.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", null, _toDisplayString(question.value.testName), 1),
                  _createElementVNode("span", null, [
                    _createTextVNode(" [" + _toDisplayString(question.value.totalOpened) + "/" + _toDisplayString(question.value.totalQuestions) + "] ", 1),
                    _createVNode(_unref(VueCountdown), {
                      time: getCountdownTime(),
                      interval: 1000,
                      onEnd: _cache[0] || (_cache[0] = () => onCountdownEndReached()),
                      class: "fw-bold"
                    }, {
                      default: _withCtx(({ days, hours, minutes, seconds, milliseconds }) => [
                        (hours > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(addLeadingZero(hours)) + ":", 1))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(addLeadingZero(minutes)) + ":" + _toDisplayString(addLeadingZero(seconds)), 1)
                      ]),
                      _: 1
                    }, 8, ["time"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  innerHTML: DOMPurify.sanitize(question.value.question),
                  class: "card-text border border-3 rounded-2 opacity-100 p-3 pb-0 mb-3"
                }, null, 8, _hoisted_6),
                _createElementVNode("table", _hoisted_7, [
                  _createElementVNode("tbody", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.value.answers, (answ, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        class: _normalizeClass((selected.value.includes(index)) ? 'test-row table-active' : 'test-row'),
                        onClick: ($event: any) => (selectAnswer(index))
                      }, [
                        _createElementVNode("th", _hoisted_10, [
                          (question.value.multiChoice)
                            ? (_openBlock(), _createElementBlock("input", {
                                key: 0,
                                class: "form-check-input",
                                type: "checkbox",
                                checked: selected.value.includes(index),
                                disabled: disabled.value
                              }, null, 8, _hoisted_11))
                            : (_openBlock(), _createElementBlock("input", {
                                key: 1,
                                class: "form-check-input",
                                type: "radio",
                                checked: selected.value.includes(index),
                                disabled: disabled.value
                              }, null, 8, _hoisted_12))
                        ]),
                        _createElementVNode("td", {
                          innerHTML: DOMPurify.sanitize(answ)
                        }, null, 8, _hoisted_13)
                      ], 10, _hoisted_9))
                    }), 128))
                  ], 512)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  (question.value.totalOpened == question.value.totalQuestions)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-sm btn-primary",
                        onClick: finishTestButtonClickHandler,
                        disabled: disabled.value
                      }, _toDisplayString(_unref(t)('page.test.end')), 9, _hoisted_15))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-sm btn-primary",
                        onClick: nextQuestion,
                        disabled: disabled.value
                      }, _toDisplayString(_unref(t)('page.test.next')), 9, _hoisted_16))
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(t)('page.test.loading')), 1)
              ])
            ]))
      ]),
      image: _withCtx(() => [
        (question.value)
          ? (_openBlock(), _createBlock(CameraFeed, {
              key: 0,
              workId: question.value.workId
            }, null, 8, ["workId"]))
          : _createCommentVNode("", true)
      ]),
      button: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-primary",
          onClick: finishTestButtonClickHandler
        }, _toDisplayString(_unref(t)('page.test.logout.end')), 1)
      ]),
      _: 1
    })
  ], 64))
}
}

})